// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"115":"f2162b87","460":"33404a12","512":"33404a12","536":"33404a12","606":"c34968db","697":"33404a12","870":"33404a12"}[chunkId] + ".chunk.css";
};